// This section name, must match the name coming from partner-orchestrator
export const PARTNER_DATA_SECTION_NAME = 'Core Data';

export const PARTNER_DATA_CORE_EDIT_HISTORY_HIDDEN_ATTRIBUTES = [
  'addressStructureType',
  'addressUId',
  'electronicAddress.addressUId',
  'electronicAddress.editedAt',
  'electronicAddress.editedBy',
  'electronicAddress.ipAddresses',
  'electronicAddress.lifecycleState',
  'electronicAddress.partnerUId',
  'electronicAddress.recordStatus',
  'electronicAddress.sftp',
  'electronicAddress.usageTypeList',
  'electronicAddress.version',
  'individualPartner.closingDate',
  'individualPartner.consentLifecycleState/AgreementLifecycleState',
  'individualPartner.Id',
  'individualPartner.individualPartnerNames',
  'individualPartner.mainDomicileCountry/CountryCode',
  'individualPartner.openingDate',
  'individualPartner.otherTitle',
  'individualPartner.partnerId',
  'individualPartner.recordStatus',
  'individualPartner.referringPartnerUId',
  'individualPartner.status',
  'individualPartner.UId',
  'individualPartner.version',
  'IndividualPartnerNameDto/nameUId',
  'IndividualPartnerNameDto/transliteratedName',
  'legalPartner.closingDate',
  'legalPartner.consentLifecycleState/AgreementLifecycleState',
  'legalPartner.editedBy',
  'legalPartner.isDiscretionary',
  'legalPartner.legalStructurePartnerNames',
  'legalPartner.openingDate',
  'legalPartner.recordStatus',
  'legalPartner.referringPartnerUId',
  'legalPartner.status',
  'legalPartner.Uid',
  'legalPartner.version',
  'LegalStructurePartnerNameDto/nameUId',
  'PartnerIdentificationDto/agreementId',
  'PartnerIdentificationDto/agreementStatus',
  'PartnerIdentificationDto/issuer',
  'PartnerIdentificationDto/toExpired',
  'partnerIdentificationList',
  'PartnerIdentifierDto/identifierIssuer',
  'PartnerIdentifierDto/identifierUId',
  'PartnerIdentifierDto/jurisdiction',
  'partnerIdentifierList',
  'partnerStructureSubType',
  'partnerStructureType',
  'phoneNumber.editedAt',
  'phoneNumber.editedBy',
  'phoneNumber.validFrom',
  'phoneNumber.validTo',
  'postalAddress.addressUId',
  'postalAddress.description',
  'postalAddress.editedAt',
  'postalAddress.editedBy',
  'postalAddress.lifecycleState',
  'postalAddress.partnerUId',
  'postalAddress.recordStatus',
  'postalAddress.usageTypeList',
  'postalAddress.version',
  'postalAddress/country.countryA2Cd',
  'postalAddress/country.ituPrefix',
];
